export function usePreOrderImage() {
  const { locale } = useI18n()

  const preOrderImage = computed(() => {
    if (locale.value === 'fr') {
      return '/images/product/Label-Pre-Order-FR.svg'
    }
    return '/images/product/Label-Pre-Order-DE.svg'
  })

  return {
    preOrderImage,
  }
}
